var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4831 20.483V48.414C47.4831 51.4992 44.9821 54.0002 41.8969 54.0002H12.1038C9.01861 54.0002 6.51758 51.4992 6.51758 48.414V20.483L27.0003 3.72437L47.4831 20.483Z",
    fill: "#FECA5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2071 25.1381C50.5689 25.1386 49.9499 24.9197 49.4539 24.518L27.0002 6.38333L4.54828 24.518C3.77193 25.145 2.72005 25.3102 1.78888 24.9514C0.857704 24.5925 0.188702 23.7642 0.0338779 22.7783C-0.120946 21.7925 0.261931 20.7989 1.03828 20.1719L25.2452 0.620225C26.2691 -0.206742 27.7313 -0.206742 28.7552 0.620225L52.9621 20.1719C53.8831 20.9157 54.2352 22.1594 53.8408 23.2756C53.4463 24.3919 52.391 25.1382 51.2071 25.1381Z",
    fill: "#E57E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9318 13.9653H26.0697C25.5555 13.9653 25.1387 13.5485 25.1387 13.0343C25.1387 12.5201 25.5555 12.1033 26.0697 12.1033H27.9318C28.446 12.1033 28.8628 12.5201 28.8628 13.0343C28.8628 13.5485 28.446 13.9653 27.9318 13.9653Z",
    fill: "#E57E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.725 17.6897H23.2767C22.7625 17.6897 22.3457 17.2729 22.3457 16.7587C22.3457 16.2445 22.7625 15.8276 23.2767 15.8276H30.725C31.2392 15.8276 31.656 16.2445 31.656 16.7587C31.656 17.2729 31.2392 17.6897 30.725 17.6897Z",
    fill: "#E57E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3789 5.96793V1.86207C35.382 0.83495 36.2139 0.00306757 37.241 0H42.8272C43.8543 0.00306757 44.6862 0.83495 44.6893 1.86207V13.4907L35.3789 5.96793Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9995 26.6504C29.0619 24.4863 31.9238 23.2658 34.9133 23.2754C39.5982 23.2754 42.827 27.6513 42.827 32.6845C42.827 37.7372 39.4893 46.4396 26.9995 50.2754C14.5096 46.4396 11.1719 37.7372 11.1719 32.6845C11.1719 27.6513 14.4007 23.2754 19.0857 23.2754C22.0752 23.2658 24.937 24.4863 26.9995 26.6504Z",
    fill: "#00BEBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8281 32.6882C42.8281 37.7344 39.495 46.4396 27.0005 50.2754C22.5543 49.0621 18.5421 46.6154 15.4277 43.2182C16.4156 42.2166 17.5411 41.3608 18.7701 40.6765C22.3546 38.684 26.8236 38.1068 29.6726 35.1554C31.4456 33.2447 32.3954 30.7129 32.3167 28.1075C32.2799 26.6416 31.9804 25.1941 31.4322 23.834C32.5551 23.4611 33.7311 23.2725 34.9143 23.2754C39.5974 23.2754 42.8281 27.6513 42.8281 32.6882Z",
    fill: "#00BEBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.18f9ce2792c2090d90b46fd46a9fcbd1.svg";
export { ForwardRef as ReactComponent };